import { useEffect, useState } from "react";
import { useConfig } from "../../../contexts/useConfig";
import ActionButtonStandard from "../Action/ActionButtonStandard";
import { useLocalSessionSettings } from "../../../contexts/useLocalSessionSettings";
import ReactGA from "react-ga4";

import { ReactComponent as EyeIcon } from "../../../assets/icons/eye.fill.svg";
import { ReactComponent as EyeSlashIcon } from "../../../assets/icons/eye.slash.fill.svg";



export default function TogglePartsButton() {
   const [config] = useConfig();
   const [localSessionSettings, updateSettings] = useLocalSessionSettings();
   const [buttonActive, setButtonActive] = useState(localSessionSettings.togglePartsActive);


   useEffect(() => {
      setButtonActive(localSessionSettings.togglePartsActive)
   }, [localSessionSettings.togglePartsActive])

      function handleClick() {

      const newButtonState = !buttonActive;
      console.log("newButtonState:", newButtonState )
      setButtonActive(newButtonState);
      updateSettings({ togglePartsActive: newButtonState });

      ReactGA.event({
         category: "Toggle Parts Button",
         action: `Toggle Parts`,
         label: newButtonState ? "true" : "false"
      });
    }

   

   return (
      config?.togglePartsConfig?.enabled && (
         <ActionButtonStandard
            className={buttonActive ? "togglePartsButton highlight" : "togglePartsButton"}
            iconImg={buttonActive ? <EyeIcon/> : <EyeSlashIcon/>}
            useSvgIcon={true}
            onClick={handleClick}
         />
      )
   );
}
